import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    cartItems: [],
};

const cartSlice = createSlice({
    name: "cart",
    initialState,
    reducers: {
        addToCart: (state, action) => {
            const { quantity, isCombo, ...restValue } = action.payload
            const item = state.cartItems.find((item) => item._id === restValue._id);
            if (item) {
                // item.quantity += quantity;
                item.quantity = quantity;

            } else {
                // state.cartItems.push({ ...restValue, quantity: quantity });
                let hasComboItem = state.cartItems.some((item) => item.isCombo);
                if ((hasComboItem && isCombo) || (!hasComboItem && !isCombo)) {
                    state.cartItems.push({ ...restValue, quantity, isCombo });
                } else {
                    state.cartItems = [{ ...restValue, quantity, isCombo }];
                }
            }
        },
        removeFromCart: (state, action) => {
            state.cartItems = state.cartItems.filter((item) => item._id !== action.payload);
        },
        updateQuantityRedux: (state, action) => {
            const { _id, type } = action.payload;
            const item = state.cartItems.find((item) => item._id === _id);
            if (item) {
                if (type === "increase") {
                    item.quantity += 1;
                } else if (type === "decrease" && item.quantity > 1) {
                    item.quantity -= 1;
                } else {
                    state.cartItems = state.cartItems.filter((item) => item._id !== _id);
                }
                item.finalPrice = item.quantity * item.price;
            }
        },
        clearCart: (state) => {
            state.cartItems = [];
        },
    },
});

export const { addToCart, removeFromCart, updateQuantityRedux, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
